import ZoneHeadViewTrainerAtd from '../../features/zoneHead/ZoneHeadViewTrainerAtd'

const ZoneHeadViewTrainerAtdPage = () => {
    return <ZoneHeadViewTrainerAtd />
}

export default ZoneHeadViewTrainerAtdPage